export default "__VITE_ASSET__de9b53ec__"